// extracted by mini-css-extract-plugin
export default {"cover":"Tm93f"};